import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IStudentsInstituteInitialState } from "../types";
import { IEntityWithIDTranslations } from "../../../../../../../types";
import { GetDeleteStudentsInstitute, GetStudentsInstitute } from "../store/thunk";

const initialState: IStudentsInstituteInitialState = {
    studentsInstitute: [],
    isStudentsInstituteRestore: false,
    selectedStudentsInstituteIDs: [],
    studentsInstituteRestore: [],
    isLoadingStudentsInstitute: true,
    filteredInstituteStudent: [],
};

const studentInstituteSlice = createSlice({
    name: "studentInstitute",
    initialState,
    reducers: {
        setStudentsInstitute: (state, action: PayloadAction<{ data: IEntityWithIDTranslations[] }>) => {
            const { data } = action.payload;
            state.studentsInstitute = data;
        },
        deletedStudentsInstitute: (state, action: PayloadAction<number>) => {
            state.studentsInstitute = state.studentsInstitute.filter(elem => elem.id !== action.payload);
        },
        updateStudentsInstitute: (state, action: PayloadAction<IEntityWithIDTranslations>) => {
            const updateData = action.payload;

            state.studentsInstitute = state.studentsInstitute.map(elem => {
                if (elem.id === updateData.id) {
                    return {
                        ...elem,
                        ...updateData,
                    };
                }
                return elem;
            });
        },
        setStudentsInstituteRestore: (state, action) => {
            state.studentsInstituteRestore = action.payload;
        },
        setIsStudentsInstituteRestore: state => {
            state.isStudentsInstituteRestore = !state.isStudentsInstituteRestore;
        },
        deletedRestoreStudentsInstitute: (state, action) => {
            state.studentsInstituteRestore = state.studentsInstituteRestore.filter(elem => elem.id !== action.payload);
        },
        setSelectedStudentsInstituteIDs: (state, action) => {
            state.selectedStudentsInstituteIDs = action.payload;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(GetStudentsInstitute.pending, state => {
                state.isLoadingStudentsInstitute = true;
            })
            .addCase(GetStudentsInstitute.fulfilled, state => {
                state.isLoadingStudentsInstitute = false;
            })
            .addCase(GetStudentsInstitute.rejected, state => {
                state.isLoadingStudentsInstitute = false;
            })
            .addCase(GetDeleteStudentsInstitute.pending, state => {
                state.isLoadingStudentsInstitute = true;
            })
            .addCase(GetDeleteStudentsInstitute.fulfilled, state => {
                state.isLoadingStudentsInstitute = false;
            })
            .addCase(GetDeleteStudentsInstitute.rejected, state => {
                state.isLoadingStudentsInstitute = false;
            });
    },
});

export const {
    setIsStudentsInstituteRestore,
    deletedStudentsInstitute,
    setSelectedStudentsInstituteIDs,
    setStudentsInstituteRestore,
    updateStudentsInstitute,
    deletedRestoreStudentsInstitute,
    setStudentsInstitute,
} = studentInstituteSlice.actions;

export default studentInstituteSlice;
